@for (doc of docs; track $index) {
  <div class="row pt-2 px-5">
    <mat-card appearance="outlined" class="pointer" (click)="openDoc(doc.path)">
      <mat-card-content class="d-flex align-items-center gap-4 px-3">
        <mat-icon class="flex-shrink-0">{{ doc.doc_icon }}</mat-icon>
        <div>
          <h5>
            {{ doc.name }}
          </h5>
          <p class="mb-0">
            {{ doc.desc }}
          </p>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
}